import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, firstValueFrom, of } from 'rxjs';
import { FeatureKey } from '../models/onboarding.model';
import { OnboardingService } from '../services/onboarding.service';

export const featureGuard: CanActivateFn = async route => {
  const required = route.data?.['requiredFeature'] as FeatureKey | undefined;
  if (!required) return true;

  const onboarding = inject(OnboardingService);
  const router = inject(Router);

  let profile = onboarding.profile();
  if (!profile) {
    profile = await firstValueFrom(
      onboarding.load().pipe(catchError(() => of(null))),
    );
  }

  if (!profile) return true;

  if (!profile.features?.[required]) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
